// import { map } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// const parseParams = (params) => {
//   const paramsStringify = JSON.stringify(params);
//   return paramsStringify.replace(/"([^"]+)":/g, '$1:').slice(1, -1);
// };
const redbookRecordInfo = `
  VehicleKey
  MakeCode
  FamilyCode
  VehicleTypeCode
  YearGroup
  MonthGroup
  SequenceNum
  Description
  CurrentRelease
  ImportFlag
  LimitedEdition
  SeriesPublic
  SeriesModelYear
  BadgeDescription
  BadgeSecondaryDescription
  BodyStyleDescription
  BodyConfigDescription
  WheelBaseConfig
  Roofline
  ExtraIdentification
  DriveDescription
  GearTypeDescription
  GearLocationDescription
  GearNum
  DoorNum
  EngineSize
  EngineDescription
  Cylinders
  FuelTypeDescription
  InductionDescription
  OptionCategory
  TradeMin
  TradeMax
  PrivateMin
  PrivateMax

  Make
  MakeName
  Model
  FamilyName
  Features {
    Feature
    EquipDescription
  }
`;

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  isUploading: false,
  // vehicleData: null
  makeOptions: [],
  modelOptions: [],
  yearOptions: [],
  badgeOptions: [],
  badge2Options: [],
  records: []
};

const slice = createSlice({
  name: 'redbook',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // // RESET VEHICLE TO INITIAL STATE
    // clearVehicleDataSuccess(state) {
    //   state.vehicleData = initialState.vehicleData;
    // },
    // RESET MODEL OPTIONS TO INITIAL STATE
    clearModelOptionsSuccess(state) {
      state.modelOptions = initialState.modelOptions;
    },

    // GET ALL MAKES
    getAllMakesSuccess(state, action) {
      state.isLoading = false;
      state.makeOptions = action.payload ? action.payload : [];
      state.error = false;
    },

    // GET MODELS OF MAKE
    getModelsOfMakeSuccess(state, action) {
      state.isLoading = false;
      state.modelOptions = action.payload ? action.payload : [];
      state.error = false;
    },

    // GET REDBOOK RECORD LIST OF MAKE AND MODEL
    getRedbookRecordListSuccess(state, action) {
      state.isLoading = false;
      state.records = action.payload ? action.payload : [];
      state.error = false;
    },

    // GET REDBOOK RECORD BY CODE
    getRedbookRecordSuccess(state, action) {
      // console.debug('getRedbookRecordSuccess: state.records =', [action.payload]);
      state.isLoading = false;
      state.records = action.payload ? [action.payload] : [];
      state.error = false;
    }
  }
});

// Reducer
export default slice.reducer;

// // Actions
// export const { onToggleFollow } = slice.actions;

// ----------------------------------------------------------------------

// export function clearVehicleData() {
//   // return clearVehicleDataSuccess();
//   return async (dispatch) => {
//     dispatch(slice.actions.clearVehicleDataSuccess());
//   };
// }
export function clearModelOptions() {
  // return clearVehicleDataSuccess();
  return async (dispatch) => {
    dispatch(slice.actions.clearModelOptionsSuccess());
  };
}

export function getAllMakes() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const queryString = `query getAllMakes {
        getAllMakes{ name code }
      }`;
      const response = await axios.post('/graphql', { query: queryString });
      dispatch(
        slice.actions.getAllMakesSuccess(response.data.data.getAllMakes)
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
export function getModelsOfMake(makeCode) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const queryString = `query getModelsOfMake {
        getModelsOfMake(makeCode: "${makeCode}") { name code }
      }`;
      const response = await axios.post('/graphql', { query: queryString });
      dispatch(
        slice.actions.getModelsOfMakeSuccess(response.data.data.getModelsOfMake)
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
export function getRedbookRecordList(makeCode, modelCode) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const queryString = `query getRedbookRecordList {
        getRedbookRecordList(makeCode: "${makeCode}", modelCode: "${
        modelCode || ''
      }") { ${redbookRecordInfo} }
      }`;
      // console.debug({ queryString });
      const response = await axios.post('/graphql', { query: queryString });
      // console.debug({ response });
      dispatch(
        slice.actions.getRedbookRecordListSuccess(
          response.data.data.getRedbookRecordList
        )
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
export function getRedbookRecord(redbookCode) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const queryString = `query getRedbookRecord {
        getRedbookRecord(code: "${redbookCode}") { ${redbookRecordInfo} }
      }`;
      // console.debug({ queryString });
      const response = await axios.post('/graphql', { query: queryString });
      // console.debug({ response });
      dispatch(
        slice.actions.getRedbookRecordSuccess(
          response.data.data.getRedbookRecord
        )
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
